// extracted by mini-css-extract-plugin
export var actions = "_a-4";
export var brand = "_a-3";
export var header = "_a-0";
export var headerContent = "_a-1";
export var identity = "_a-5";
export var logo = "_a-2";